import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import {
  ReportServiceDeskIssueError,
  ReportServiceDeskIssueRequest,
  ReportServiceDeskIssueResponse,
} from '@/api/model';

const request = {
  postReportServiceDeskIssue: async ({ payload }: ReportServiceDeskIssueRequest) => {
    const { data } = await fetchClient.FCT.post<ReportServiceDeskIssueResponse>(
      ENDPOINTS.FCT.APPS.REPORT_SERVICE_DESK_ISSUE,
      { body: payload },
    );

    return data;
  },
};

const mutation = {
  usePostReportServiceDeskIssue: () =>
    useMutation<
      ReportServiceDeskIssueResponse,
      ReportServiceDeskIssueError,
      ReportServiceDeskIssueRequest
    >({
      mutationFn: request.postReportServiceDeskIssue,
    }),
};

export const reportServiceDeskIssue = {
  mutation,
  request,
};
